import { TableResponse } from ".";

export enum WalletRequestStatus {
    PENDING = "Pending",
    APPROVED = "Approved",
    REJECTED = "Rejected",
}

export interface WalletRequest {
  id: number;
  member_id: number;
  member_name: string;
  request_amount: number;
  wallet_id: string;
  user_type:string;
  receipt_url: string;
  status: WalletRequestStatus;
  rejection_reason?: string;
  created_at: string;
  created_by: number;
  updated_at: string;
  updated_by: number;
}


export interface RefundRequest{
  id: number;
  member_name: string;
  wallet_balance: number;
  product_id:number;
  wallet_address:string;
  processed_at?: string;
  user_id: number;
  amount: number;
  notes?: string;
  status: WalletRequestStatus;
  rejection_reason?: string;
  created_at: string;
  updated_at: string;
}
export type WalletRequestResponse = TableResponse<WalletRequest>;

export type RefundRequestResponse = TableResponse<RefundRequest>;
